import chinaJSON from './china.json';
import loginBg from './login-bg.png';
import classDefault from './class-default.png';
import empty from './images/empty.png';
import bianji from './images/bianji.svg';
import bianjiCur from './images/bianji_cur.svg';

export default {
  chinaJSON,
  loginBg,
  empty,
  classDefault,
  bianji,
  bianjiCur
};



// WEBPACK FOOTER //
// ./src/assets/index.js